'use client';
import * as React from 'react';

/* eslint-disable  @typescript-eslint/no-unused-vars*/ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/**
 * @subcomponent ProgressiveImage
 */ class ProgressiveImageBase extends React.Component {
    componentDidMount() {
        const { src, srcSetData } = this.props;
        this.loadImage(src, srcSetData);
    }
    componentDidUpdate(prevProps) {
        const { src, placeholder, srcSetData } = this.props;
        // We only invalidate the current image if the src has changed.
        if (src !== prevProps.src) {
            this.initializeState(src, placeholder, srcSetData);
        }
    }
    componentWillUnmount() {
        if (this.image) {
            this.image.onload = null;
            this.image.onerror = null;
        }
    }
    initializeState(src, placeholder, srcSetData) {
        this.setState({
            image: placeholder,
            loading: true
        }, ()=>{
            this.loadImage(src, srcSetData);
        });
    }
    render() {
        const { image, loading, srcSetData } = this.state;
        const { children } = this.props;
        if (!children || typeof children !== 'function') {
            throw new Error(`ProgressiveImage requires a function as its only child`);
        }
        return children(image, loading, srcSetData);
    }
    constructor(props){
        super(props);
        _define_property(this, "image", void 0);
        _define_property(this, "loadImage", (src, srcSetData)=>{
            // If there is already an image we nullify the onload
            // and onerror props so it does not incorrectly set state
            // when it resolves
            if (this.image) {
                this.image.onload = null;
                this.image.onerror = null;
            }
            const image = new Image();
            this.image = image;
            image.onload = this.onLoad;
            image.onerror = this.onError;
            image.src = src;
            if (srcSetData) {
                image.srcset = srcSetData.srcSet;
                image.sizes = srcSetData.sizes;
            }
        });
        _define_property(this, "onLoad", ()=>{
            // use this.image.src instead of this.props.src to
            // avoid the possibility of props being updated and the
            // new image loading before the new props are available as
            // this.props.
            if (this.props.delay) {
                this.setImageWithDelay();
            } else {
                this.setImage();
            }
        });
        _define_property(this, "setImageWithDelay", ()=>{
            setTimeout(()=>{
                this.setImage();
            }, this.props.delay);
        });
        _define_property(this, "setImage", ()=>{
            var _this_image, _this_image1, _this_image2;
            this.setState({
                image: ((_this_image = this.image) === null || _this_image === void 0 ? void 0 : _this_image.src) || '',
                loading: false,
                srcSetData: {
                    srcSet: ((_this_image1 = this.image) === null || _this_image1 === void 0 ? void 0 : _this_image1.srcset) || '',
                    sizes: ((_this_image2 = this.image) === null || _this_image2 === void 0 ? void 0 : _this_image2.sizes) || ''
                }
            });
        });
        _define_property(this, "onError", (errorEvent)=>{
            const { onError } = this.props;
            if (onError) {
                onError(errorEvent);
            }
        });
        this.image = undefined;
        this.state = {
            image: props.placeholder,
            loading: true,
            srcSetData: {
                srcSet: '',
                sizes: ''
            }
        };
    }
}

export { ProgressiveImageBase };
